// eslint-disable-next-line import/prefer-default-export
export const HolidayStatus = Object.freeze({
  Loading: 1,
  Failed: 2,
  Success: 3,
  NoData: 4,
});
